<div class="page-wrapper">
  <!-- Welcome screen lives OUTSIDE the scrollable container so
       the brand icon (position:absolute; left:-104px) is never clipped -->
  <div *ngIf="!executeCommandList.length" class="welcome-area">
    <si-ai-welcome-screen>
      <p class="h1 mb-0"> <strong>Hello</strong>, </p>
      <p class="h1 mb-0">how can I help you today?</p>
    </si-ai-welcome-screen>
  </div>

  <!-- Messages thread – only rendered when there are messages -->
  <div *ngIf="executeCommandList.length" class="thread-container">
    <div *ngFor="let cmd of executeCommandList; let id = index">
      <si-user-message
        [content]="cmd?.inputMessage ?? ''">
      </si-user-message>

      <div class="markdown-content mt-7">

        <div class="mb-7 editor-margin">
          <!-- Streaming new version V2-->
          <div *ngFor="let streamingMsg of cmd?.streamingMessages; let msgIndex = index">
            <ng-container>

              <!-- kind: status Status Messages (with custom-font class) -->
              <div *ngIf="isStatusMessage(streamingMsg)" class="mb-3 custom-font">
                {{ streamingMsg.message }}
              </div>

              <!-- kind:content contentType: Text (string) - Content Messages with Text (Markdown) -->
              <div *ngIf="shouldShowTextContent(streamingMsg)" class="mb-4 content-text"
                [ngClass]="{'content-error': streamingMsg.phase === 'error'}">
                <div [innerHTML]="getContentDisplay(streamingMsg)"></div>
              </div>

              <!-- kind: content contentType:code (string) - Code Content Messages with Code (Read-only Monaco Editor) -->
              <div *ngIf="shouldShowCodeEditor(streamingMsg)" class="mb-4">
                <div class="monaco-editor-container editor-block">
                  <app-monaco-code-editor [code]="streamingMsg.content || ''" [editorOptions]="editorOptions"
                    [editorHeight]="calculateHeight(streamingMsg.content)">
                  </app-monaco-code-editor>
                </div>
              </div>

              <!-- kind: content contentType:code (object) - Code with Text and Code separately -->
              <div *ngIf="shouldShowCodeAsObject(streamingMsg)" class="mb-4">
                <!-- Display final Summary portion -->
                <div *ngIf="getTextFromCodeObject(streamingMsg)" class="mb-3 content-text">
                  <div [innerHTML]="getTextFromCodeObject(streamingMsg)"></div>
                </div>

              </div>

              <!-- kind: control Control Messages -->
              <div
                *ngIf="cmd?.currentStreamingState === 'progress' && (streamingMsg.kind === 'control' && streamingMsg.message)"
                class="mb-3 text-muted">
                <em>{{ streamingMsg.message }}</em>
              </div>
            </ng-container>
          </div>

          <div
            *ngIf="cmd?.currentStreamingState === 'progress' || cmd?.currentStreamingState === 'run_waiting'">
            <img src="assets/images/waveform-progress.svg" alt="Processing"
              style="height: 50px; vertical-align: middle;" />
          </div>
        </div>

      </div>

      <!-- Python code generated from workflow  -->
      <div class="mb-1" style="clear: both;" *ngIf="!cmd?.isStreaming && cmd?.currentStreamingState === 'run_complete'">
        <div *ngIf="cmd?.sendMessageError">{{cmd?.sendMessageError}}</div>
        <div [innerHTML]="cmd?.text" class="mb-7 editor-margin"></div>
        <div class="editor-margin monaco-editor-container">
          <div class="action-bar">
            <div class="feedback">
              <button type="button" title="Like" class="btn btn-circle btn-sm element-thumbs-up"
                [ngClass]="cmd?.feedback === 'up' ? 'btn-primary' : 'btn-tertiary'" (click)="onSendFeedback(cmd, 'up')"
                aria-label="Like">
              </button>
              <button type="button" title="Dislike" class="btn btn-circle btn-sm element-thumbs-down"
                [ngClass]="cmd?.feedback === 'down' ? 'btn-primary' : 'btn-tertiary'"
                (click)="onSendFeedback(cmd, 'down')" aria-label="Dislike">
              </button>
            </div>
          </div>
        </div>
        <br /> <br />
      </div>
    </div>
  </div>




  <!-- Chat Box fixed at the bottom with matching width -->
  <div class="footer" [class.streaming]="isStreaming">

    <si-chat-input #chatInput
      [value]="inputMessageText"
      (valueChange)="onInputChange($event)"
      placeholder="Enter a command, question or topic..."
      [actions]="chatInputActions"
      [sending]="sending()"
      [interruptible]="isStreaming"
      [accept]="acceptedFileTypes"
      [disabled]="tokenUsageFailed()"
      (send)="onSendMessage($event)"
      (interrupt)="onStopWorkflow()"
      [attachments]="chatAttachments"
      (attachmentsChange)="onAttachmentsChange($event)">

      <!-- Settings: Insights & Auto Code Correction toggles -->
      <button type="button" class="btn btn-icon btn-ghost element-settings user-settings-btn"
        [cdkMenuTriggerFor]="userSettingsMenu"
        [disabled]="isStreaming || tokenUsageFailed()">
      </button>

      <ng-container *ngIf="tokenUsage() as usage">
        <ng-template #tokenUsageTooltip>
          <div class="token-usage-content" style="white-space: nowrap; line-height: 1.8; padding: 8px 12px;">
            <div><strong>Token Usage &mdash; Monthly</strong></div>
            <div><strong>This Month: {{ usage.total_tokens }}/{{ usage.max_tokens }}</strong> tokens</div>
            <div><strong>Usage: {{ getUsagePercent(usage.total_tokens, usage.max_tokens) }}%</strong> of quota</div>
          </div>
        </ng-template>
        <button type="button" class="btn btn-icon btn-ghost element-multistate token-usage-btn"
          [siTooltip]="tokenUsageTooltip" placement="top" aria-label="Token usage" [disabled]="isStreaming">
        </button>
      </ng-container>

      <ng-container *ngIf="isElectronMode && psseVersions.length > 0">
        <button type="button" class="btn btn-ghost psse-version-btn"
          [cdkMenuTriggerFor]="psseVersionMenu" [disabled]="isPsseDropdownDisabled">
          {{ selectedPsseVersion }}<span class="element-down-2"></span>
        </button>
      </ng-container>

      <div siChatInputDisclaimer class="text-center text-muted si-caption">
        <span>ⓘ </span>
        <span>This content is generated by an AI system. Content should not be relied upon as a substitute for
          professional advice.</span>
      </div>
    </si-chat-input>

    <ng-template #userSettingsMenu>
      <si-menu class="setting-btn gap-4">
        <button si-menu-item (triggered)="onToggleInsights()">
          <span class="element-info"
            [siTooltip]="UserSettingsTooltip.ResultsInsights"
            placement="start"
            (click)="$event.stopPropagation()">
          </span>
          Automated Results Insights
          <div class="end ms-6">
            <div class="form-check form-switch mb-0">
              <input type="checkbox" class="form-check-input" role="switch"
                [checked]="userSettingsService.settings().insights_enabled"
                (click)="onToggleInsights(); $event.stopPropagation()" />
            </div>
          </div>
        </button>
        <button si-menu-item (triggered)="onToggleAutoCode()">
          <span class="element-info"
            [siTooltip]="UserSettingsTooltip.AutoCodeCorrection"
            placement="start"
            (click)="$event.stopPropagation()">
          </span>
          Automated Code Execution
          <div class="end ms-6">
            <div class="form-check form-switch mb-0">
              <input type="checkbox" class="form-check-input" role="switch"
                [checked]="userSettingsService.settings().auto_code_correction"
                (click)="onToggleAutoCode(); $event.stopPropagation()" />
            </div>
          </div>
        </button>
      </si-menu>
    </ng-template>

    <ng-template #psseVersionMenu>
      <si-menu>
        <si-menu-header>PSS®E Version</si-menu-header>
        <si-menu-item-radio *ngFor="let version of psseVersions" [checked]="selectedPsseVersion === version"
          (triggered)="onPsseVersionChange(version)">
          {{ version }}
        </si-menu-item-radio>
      </si-menu>
    </ng-template>
  </div>
</div>